import React from 'react';
import styles from '../TableFooterLegend/styles.css';

export default function TableLegend({ legend }) {
	return (
		<div className={styles.legendWrapper}>
			{legend.map((item, index) => (
				<div className={styles.itemWrapper} key={`table-legend-${index}`}>
					<div className={`${styles[item.class]} ${styles.indicator}`} />
					<div>{item.label}</div>
				</div>
			))}
		</div>
	);
}
